.panel {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 24px;
}

.heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 12px;
}

.label {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text);
}

.note {
  font-size: 0.82rem;
  color: var(--muted);
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin-bottom: 14px;
}

.legendItem {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--accent);
}

.legendItem::before {
  content: "";
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: var(--accent);
}

.empty {
  font-size: 0.9rem;
  color: var(--muted);
  padding: 12px 0;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.row {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.equip {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--soft);
}

.sides {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

/* Three fixed, right-aligned numeric columns with one shared gap, so %, set
   count and Δ each line up vertically and sit equally spaced like a table. */
.side {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 36px 40px 46px;
  align-items: center;
  gap: 10px;
}

.track {
  height: 8px;
  border-radius: 4px;
  background: var(--tint-md);
  overflow: hidden;
}

.fill {
  height: 100%;
  border-radius: 4px;
  background: var(--accent);
  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.pct,
.sets {
  font-size: 0.82rem;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: right;
  color: var(--accent);
}

.delta {
  font-size: 0.8rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: left;
}

.delta.up   { color: var(--up); }
.delta.down { color: var(--down); }
.delta.flat { color: var(--muted); }
